import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

const store = createStore({
    state() {
        return {
          iframePath: null,
          language: navigator.language.replace("-", "_").toUpperCase(),
          currentMenu: {
                parent: '',
                current: '',
                detail: ''
            },
          menu: null,
          status: null,
          systemType: "PEGAPortal"
        };
    },
    mutations: {
        setIframePath(state, path) {
            state.iframePath = path;
        },
        setLanguage(state, lang){
            state.language = lang;
        },
        setCurrentMenu(state, item){
            state.currentMenu = item;
        },
        setMenu(state, item){
            state.menu = item;
        },
        setStatus(state, item){
            state.status = item;
        }
    },
    plugins: [ createPersistedState() ],
});

export default store;